import propsTag from '@/js/util/props/propsTag'
import carousel from '@/js/util/symbols/carousel'

export default {
  provide() {
    return { [carousel]: this }
  },
  props: {
    ...propsTag,
  },

  data() {
    return {
      items: [],
      currentItem: undefined,
      buttons: [],
      currentButton: undefined,

      animationState: false,
    }
  },

  created() {
    // carousel direction has callback which
    // is a string prop either previous or next
    this.$on('carousel:direction', button => this[`${button.direction}Item`](button))

    // set item
    this.$on('set:item', this.setItem)
    // creates items
    this.$on('create:items', this.createItems)
    // create buttons
    this.$on('create:buttons', this.createButtons)
    // disable button until animation is done
    this.$on('animation:state', this.toggleAnimationState)
  },

  computed: {
    currentItemIndex() {
      return this.items.indexOf(this.currentItem)
    },
  },

  methods: {
    setItem(item) {
      this.currentItem = item
    },
    setButton(button) {
      this.currentButton = button
    },

    createItems(item) {
      this.items.push(item)

      if (!this.currentItem) {
        this.setItem(item)
      }
    },
    createButtons(button) {
      this.buttons.push(button)
    },

    nextItem(button) {
      this.setButton(button)
      this.carouselDirection(this.currentItemIndex + 1)
    },
    previousItem(button) {
      this.setButton(button)
      this.carouselDirection(this.currentItemIndex - 1)
    },

    carouselDirection(direction) {
      const { items } = this
      const { length } = items
      // break this out
      const currentItem = items[(((direction) % length) + length) % length]

      this.setItem(currentItem)
    },

    toggleAnimationState(state) {
      const { currentButton } = this
      if (!state && currentButton) {
        setTimeout(() => {
          currentButton.$el.focus()
        }, 1)
      }
      this.animationState = state
    },
  },

  render(createElement) {
    return createElement(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/carousel/CarouselContainer.js